import SessionModel from '../models/SessionModel';
import SwabComponentModel from '../models/SwabComponentModel';
import {
    SET_VIEWING_RESULT,
    SessionActionTypes,
    ISessionState,
    SET_SELECTED_COLLECTION,
    SET_WAREHOUSE_CREATED,
    SET_SESSIONS_CHANGE,
    SET_DISPLAY_SESSION_SIDEBAR,
    SET_SELECTED_SESSION,
} from './types';

export const sessionInitialState: ISessionState = {
    result: new SwabComponentModel(),
    selectedCollection: 0,
    warehouseCreated: false,
    sessionsChange: false,
    sessionSidebar: false,
    selectedSession: new SessionModel(),
};

export function sessionReducer(state = sessionInitialState, action: SessionActionTypes): ISessionState {
    switch (action.type) {
        case SET_VIEWING_RESULT:
            return {
                ...state,
                result: action.payload,
            };

        case SET_SELECTED_COLLECTION:
            return {
                ...state,
                selectedCollection: action.payload,
            };

        case SET_WAREHOUSE_CREATED:
            return {
                ...state,
                warehouseCreated: action.payload,
            };

        case SET_SESSIONS_CHANGE:
            return {
                ...state,
                sessionsChange: action.payload,
            };

        case SET_DISPLAY_SESSION_SIDEBAR:
            return {
                ...state,
                sessionSidebar: action.payload,
            };

        case SET_SELECTED_SESSION:
            return {
                ...state,
                selectedSession: action.payload,
            };

        default:
            return state;
    }
}
